import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { VisuallyHidden } from '@change-corgi/design-system-legacy/a11y';
import { iconVictory } from '@change-corgi/design-system-legacy/icons';

import { useIsSunriseEnabled } from '../../hooks/isSunriseEnabled';
import { usePetitionDetails } from '../../hooks/petitionDetails';
import { ShareContainer } from '../share';
import { SignatureStatsVictoryContainer } from '../stats/signatureStats';

import { SidePetitionStatus } from './components/SidePetitionStatus';

export function SideVictoryContainer(): JSX.Element {
	const { isVerifiedVictory } = usePetitionDetails();
	const {
		data: { isSunriseEnabled },
	} = useIsSunriseEnabled();
	return (
		<>
			<SidePetitionStatus
				icon={iconVictory}
				headingColor={isSunriseEnabled ? 'sunrise.semantic.typography.inverse.strong' : undefined}
				iconColor={isSunriseEnabled ? 'sunrise.semantic.icon.inverse.strong' : 'primary-changeRed'}
				background={
					isSunriseEnabled
						? 'var(--Background-Dark-1, linear-gradient(90deg, var(--Blue-600, #0D4DFB) 36%, var(--Blue-500, #4771FF) 100%));'
						: 'primary-greyBackground'
				}
			>
				{isVerifiedVictory ? (
					<Translate value="fe.pages.petition_show.status.confirmed_victory" />
				) : (
					<Translate value="fe.pages.petition_show.status.victory" />
				)}
			</SidePetitionStatus>
			<SignatureStatsVictoryContainer textAlign="left" />
			<VisuallyHidden as="h2">
				<Translate value="fe.components.petition_share.action" />
			</VisuallyHidden>
			<ShareContainer forMobileView={false} />
		</>
	);
}
